import type { CmxDocumentContentSlotEntry } from './cmxDocumentContentSlot';

/**
 * `noteType` off the first matched rendition, else positional `Note #N` (1-based) within the
 * cmx-document-content entries specifically -- legacy notes have their own label and are numbered
 * separately, per the outcome this slot was built for. Shared between `NoteNav` (the tab) and
 * `SourceDocumentModal` (the modal header) so the two never drift.
 */
export function cmxDocumentContentLabel(
  entry: CmxDocumentContentSlotEntry,
  index: number
): string {
  return entry.renditions?.[0]?.noteType ?? `Note #${index + 1}`;
}
